import useQuery from '../useQuery';

/** M31 (#491): the fulfillment (if any) for a single sale. Filtered by `sale`,
 * so the paginated list carries 0 or 1 rows in the COMPACT shape (`last_event`,
 * no timeline). The panel reads `data.results[0] ?? null`; `count === 0` means
 * no fulfillment exists yet. Any member can read; writes are writer-only.
 * Mirrors the list-query convention (`queryParams` → the shared query key). */
function useSaleFulfillmentQuery(sellerId, saleId, params) {
  return useQuery(`/shipping/${sellerId}/fulfillments/`, {
    queryParams: { sale: saleId },
    enabled: Boolean(sellerId && saleId),
    ...params,
  });
}

export default useSaleFulfillmentQuery;
